import React, { useEffect } from "react"
import { useAuth } from "./auth"
import { LoadingScreen } from "./ui"
import { Shell } from "./Shell"
import { useNavigate, usePath } from "./router"
import { AuthPage } from "./pages/AuthPage"
import { DashboardPage } from "./pages/DashboardPage"
import { TeamsPage } from "./pages/TeamsPage"
import { TeamPage } from "./pages/TeamPage"
import { GamePage } from "./pages/GamePage"
import { PracticePage } from "./pages/PracticePage"
import { SettingsPage } from "./pages/SettingsPage"
import { PublicTeamPage } from "./pages/PublicTeamPage"
import { ResetPasswordPage } from "./pages/ResetPasswordPage"
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage"
import { StaticPage } from "./pages/StaticPage"
import { GroupMeCallbackPage } from "./pages/GroupMeCallbackPage"
import { GamesPage } from "./pages/GamesPage"
import { PlayerPage } from "./pages/PlayerPage"
import { NotFoundPage } from "./pages/NotFoundPage"
import { AccountMigrationPage } from "./pages/AccountMigrationPage"

export function App() {
  const { session, loading } = useAuth()
  const path = usePath()
  const navigate = useNavigate()
  if (loading) return <LoadingScreen />
  if (/^\/pages\/[^/]+\/?$/.test(path)) return <PublicTeamPage />
  if (path === "/forgot-password") return <ForgotPasswordPage />
  if (path === "/reset-password") return <ResetPasswordPage />
  if (["/landing", "/privacy", "/terms"].includes(path)) return <StaticPage page={path.slice(1)} />
  if (!session && path === "/") return <Redirect to="/landing" navigate={navigate} />
  if (!session && path === "/login") return <AuthPage />
  if (!session) return <AuthPage />
  if (path === "/login") return <Redirect to="/" navigate={navigate} />
  if (!["completed", "not_required"].includes(session.backend_migration?.state)) return <AccountMigrationPage />
  if (path === "/groupme/callback") return <GroupMeCallbackPage />

  let page = path === "/" ? <DashboardPage /> : <NotFoundPage />
  if (path === "/teams") page = <TeamsPage />
  else if (path === "/games") page = <GamesPage />
  else if (/^\/teams\/[^/]+\/?$/.test(path)) page = <TeamPage />
  else if (/^\/players\/[^/]+\/?$/.test(path)) page = <PlayerPage />
  else if (/^\/games\/[^/]+\/?$/.test(path)) page = <GamePage />
  else if (/^\/practices\/[^/]+\/?$/.test(path)) page = <PracticePage />
  else if (path === "/settings") page = <SettingsPage />

  return <Shell>{page}</Shell>
}

function Redirect({ to, navigate }) {
  useEffect(() => navigate(to, { replace: true }), [navigate, to])
  return <LoadingScreen />
}
